<!-- 充值页面 -->
<template>
 <div>
    <div class="page home animated bounceInUp" id="charge_index">
              <div @click="istab= false" v-show="istab" class="tabbox nobg">
                  <div class="hadtabs">
                      <ul>
                          <li >  <router-link to="/h5home">官网首页</router-link> </li>
                          <li class="active"><router-link to="/h5recharge">账户充值</router-link> </li>
                           <li ><router-link to="/h5enlist">主播招募</router-link> </li>
                          <!-- <li><router-link to="/h5aboutus">关于我们</router-link></li> -->
                          <li><router-link to="/h5contactus">联系我们</router-link></li>
                      </ul>
                  </div>
             </div>
                <div class="bd">
                    <div class="heradbox">
                      账号充值
                      <i @click="istab = true" class="tabicon"></i>
                    </div>
                    <!-- 已登录 -->
                    <div  v-if="!islogin" class="weui_cells inpubox" >
                        <input v-model="userid" type="number"  maxlength="11" id="uid_input"
                         class="uid_input" placeholder="请输入暖暖星球号">
                            <a   class="switch_login"    @click="checkUser()">确认</a>     
                    </div>
                    <div v-else   class="userof ">
                        <img class="userimg" :src="usinfo.head" alt="">
                        <div class="headbox">
                          <p>{{usinfo.name}}</p>
                          <p>暖暖星球ID: {{usinfo.uid}}</p>
                        </div>
                        <p @click="changeuid()" class="chargenum">更换账号</p>
                    </div>  
                    <div class="txtmsg">
                        <span class="head">请宝宝们确认此ID无误</span>
                        <span @click="dialogTabxieyi= true" class="headri">如何获取暖暖星球ID？</span>
                    </div>
                    <!--vipTab-->
                    <div class="tabs">
                        <span @click="changetab(1)" :class="iszuan?'active':'' ">充值钻石</span>
                        <span @click="changetab(2)"   :class="!iszuan?'active':'' ">开通VIP</span>
                    </div>
                        <!-- 充值列表 -->
                    <!-- <div class="weui_cells" id="charge_list">
                    </div> -->
                    <div class="con_box">
                        <div class="listbox" v-if="iszuan"  >
                        <p class="list_title">选择套餐</p>
                            <ul class="listul">
                                <li @click="changeextra(index,item.code,item.price)"  v-for="(item,index) in chargeList" :key="index"  :class="list_index==index?'active':'' " >
                                    <p> <span>{{item.jewel}}</span>钻</p>
                                    <p>¥{{item.price}}</p>
                                    <i :class="list_index==index?'activeicon':'' " ></i>
                                    <span v-if="item.awardExtra!=0" class="songicon">送{{item.awardExtra}}钻</span>
                                </li>
                            </ul>
                       <!-- <p class="zdy_title">自定义充值金额 <span>单笔充值最低2元，最高10000元</span></p>
                        <div class="zdybox">
                          <input  @blur="zdyinputblur" @input="zdyinputchange"  v-model="zdyinputval" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" class="zdyinput"  type="number">
                         <span class="zdytxt">  {{zdytxt}}</span>
                        </div> -->

                        </div>
                    <!--VIP-->
                    <div class="vip" v-else>
                        <span class="head">贵族类型</span>
              
                   <ul class="listhy">
                     
                            <li @click="changeextra(index,item.list[0].code,item.list[0].price)" :class="list_index==index?'active':'' " v-for="(item,index) in knightList"  :key="index"  >
                              <span v-if="index==2" class="songicon">最多人选</span>
                                <p> {{item.name}} </p>
                                <i class="activeicon"></i>  
                            </li>
                    
                        </ul>  
                        <!-- <div class="vip_tab">
                            <span @click=" changetab(3)" :class="!isking?'span0_on':'span0_off' " ></span>
                            <span  @click=" changetab(4)" :class="!isking?'span1_off':'span1_on' " ></span>
                        </div> -->
              
                        <span class="head">开通时长</span>
                <div class="vip_time_tabs">
                      <div class="vip_time">
                        <p>¥{{knightList[list_index].list[0].price }}元/{{knightList[list_index].list[0].days }}天 </p>
                        <i class="songicon">月度</i> 
                      </div>
                      <p class="vip_time_txt">开通立即获得 {{knightList[list_index].list[0].rewardJewel }} 钻石</p>
                    </div>
                        <!-- <div class="vip_time_tabs">
                       <span  @click="changeextra(index,item.code,item.price)" v-for="(item,index) in (isking?kingList:knightList)" :key="index" 
                      :class="list_index==index?'active':'' " >{{item.name}}<i>￥{{item.price}}</i></span>
                

                        </div> -->
                        <!-- <span class="button" id="vip_button"></span> -->
                

                
                </div>
                <h5 class="playtitle">选择支付方式</h5>
                <div class="play">
                <span @click=" getChargeOrderForH5('WX') "  class="wxlay"></span>
                <span  @click=" getChargeOrderForH5('ali') "  class="zfbplay"></span>
                </div>
                    <!-- <div class="help_info" id="help_info_btn">如何找到自己的暖暖星球号?</div> -->
        
                </div>
                      <div v-if="tidialog"  class="tanbox">
                  <div class="tixianbox">
                      <h5 class="title">充值信息确认</h5>
                      <!-- <h6>¥33元</h6> -->
                      <p> <span>充值ID:</span> <span>{{userid}}</span>  </p>
                      <p> <span>充值昵称:</span> <span>{{usinfo.name}}</span>  </p>
                      <p v-if="!iszuan"> <span>开通贵族:</span> <span style="color:#FF205E">{{knightList[list_index].name}}</span>  </p>
                      <p v-if="!iszuan"> <span>开通信息:</span> <span style="color:#333">{{play_price+'元/'+knightList[list_index].list[0].days+'天'}}</span>  </p>
                      <p v-if="iszuan"> <span>充值金额:</span> <span style="color:#FF205E">{{play_price}}元</span>  </p>
                      <p > <span>充值方式:</span> <span >{{iswxplay?'微信':'支付宝'}}</span>  </p>
                       <h6>提示：请核对以上信息，核对确认后平台概不负责</h6>
                      <div class="btns">
                          <button  @click="tidialog=false">取消</button>
                          <button @click="play()">确认</button>
                      </div>
                  </div>
              </div>
                    <div class="cztxt">
                   <p>未成年人禁止充值消费。</p>
                   <p>提示：请您警惕任何以兼职刷单、假冒客服等理由的交易骗局，请勿上当受骗。</p>
                </div>
                <div v-if="!iszuan"  class="bottom_tips">
                  如有相关VIP疑问请联系客服QQ：<span style="color: #FF205E;"  id="share-code" data-clipboard-text="800181050">800181050</span>
                    <input data-clipboard-action="copy" class="cobyOrderSn wxfuzhi" data-clipboard-target="#share-code" type="button" value="复制"  @click="copyUrl3()">
                </div>
        
                <div v-if="iszuan" class="bottom_tips">大额充值请联系微信：
                <span style="color: #FF205E;"  id="share2-code" data-clipboard-text="nnzb_tu">nnzb_tu</span>
                    <input type="button" data-clipboard-action="copy" data-clipboard-target="#share2-code"    value="复制" 
                     class="cobyOrderSn2 wxfuzhi"  @click="copyUrl2()"> 进行详细了解。
            </div>
            </div>

    </div>


    <!-- 充值确认弹框 -->

    <!-- 充值成功弹框 -->
      <el-dialog custom-class='h5chongzhidialog' title="如何查看暖暖星球ID" :visible.sync="dialogTabxieyi">
          <div class="dia_xybox"> 
          <p>第一步：打开个人主页-进入编辑资料</p> 
          <img src="https://resource.imbeiyu.com/gw/assets/images2/web/pic_guide_1.png" alt=""> 
          <p>第二步：复制暖暖星球号</p>  
          <img  src="https://resource.imbeiyu.com/gw/assets/images2/web/pic_guide_2.png" alt=""> 
          </div>
      </el-dialog>
 
    <div v-html="zhifubao" class="zhifubao"></div>
 </div>
</template>
<script>
// import Clipboard from 'clipboard';
export default {

    data(){
        return{
         iszuan:true,//是否充值钻石
         istab:false,
         dialogTabxieyi:false,
         tidialog:false,
          islogin:false, 
          isplay:false, // 是否是支付页面
          isking:false, // 是否是国王VIP
          iswxplay:true,  //是否微信充值
           zdyinputval:'', // 自定义充值
          zdytxt:'元/0钻',
          userid:'',
          play_price:6,
          isios:0,
          playcode:null,
          zhifubao:null,
          chargeType:"WX", // 支付宝 ali
          usinfo:{}, // 用户信息
          list_index:0,
          hasBuyVip:false,
          kingList:[],
          knightList:[],
          chargeList:[],
          orderInfo:{},
        }
    },
     created(){
          this.getVIPchargelist()
        this.getChargeList()
       this.isios= this.is_ios()?1:0

    },

    methods:{
       changeextra(index,code,price){
      this.list_index = index
      this.playcode = code
      this.play_price = price
      this.zdyinputval = ''
       this.zdytxt='元/0钻'

    },
      copyUrl3(){
           var _this = this;
        var clipboard = new this.clipboard(".cobyOrderSn");
        clipboard.on('success', function () {
           _this.$message({ message: '复制成功',  customClass:"h5msg", type: 'success'  });
        });
        clipboard.on('error', function () {
        });
      },
      copyUrl2(){
           var _this = this;
        var clipboard = new this.clipboard(".cobyOrderSn2");
        clipboard.on('success', function () {
           _this.$message({ message: '复制成功',  customClass:"h5msg", type: 'success'  });
        });
        clipboard.on('error', function () {
        });
      },
         checkUser(){  //查询暖暖星球号
        var _this = this
        console.log(this.userid)
        if(!_this.userid){
            _this.$message({ message: '请输入暖暖星球ID',  customClass:"h5msg", type: 'error'  });
            return
        }

      _this.$http.get(_this.$api.checkUser, {
        params: {
          type: 0,
          uid: _this.userid,
        }
      }).then(function (response) {
        console.log(response);
        if(response.data.state){
            _this.islogin = true
         _this.usinfo =  response.data 

        
        }else{
            _this.$message({ message: response.data.msg,  customClass:"h5msg", type: 'error'  });
        }
          _this.getVIPchargelist()
        //  _this.$message({
        //   message: '恭喜你，这是一条成功消息',
        // });
      
      })
    },
    changeuid(){ // 切换账号
       this.islogin = false
       this.userid = ''
       this.usinfo ={}

    },
  changetab(num){
   
      if(num == 1){
            this.list_index = 0
        this.iszuan = true
      this.playcode = this.chargeList[0].code
      this.play_price =this.chargeList[0].price

      }else if(num ==2){
       this.iszuan = false 
          this.list_index = 2

        this.playcode = this.knightList[2].list[0].code
        this.play_price =this.knightList[2].list[0].price
      }
    },
    getVIPchargelist(){ // 查询vip
    var _this = this
      _this.$http.get(_this.$api.getVipChargeList, {
            params: {
              type: 0,
              uid: _this.userid?_this.userid:0,
            }
          }).then(function (response) {
            console.log(response);
           _this.knightList= response.data.data.data 
          
          })
    },
    getChargeList(){ 
    var _this = this
      _this.$http.get(_this.$api.getChargeList).then(function (response) {
            console.log(response.data);
           _this.chargeList= response.data.result
           _this.play_price= response.data.result[0].price
           _this.playcode= response.data.result[0].code
          
          })
    },

       zdyinputblur(){
      console.log(this.zdyinputval)
             if(this.zdyinputval ==0 || this.zdyinputval=='' ){
              this.list_index  =0 
                this.play_price= this.chargeList[0].price
           this.playcode= this.chargeList[0].code

        }else{
          this.list_index =99       
        } 
    },
    zdyinputchange(){
         console.log(this.zdyinputval)
    if(this.zdyinputval >=10000){
        this.zdyinputval =10000
      
     }
       this.playcode= -999
        this.play_price =  this.zdyinputval
        this.zdytxt = "元/"+(this.zdyinputval*10)+"钻"
    }, 
    getChargeOrderForH5(chargeTypeStr){ 
    var _this = this
    
      if(!_this.islogin){ // 没有登陆了
              
                if(_this.userid == ''){
                   _this.$message({ message: '输入暖暖星球号才可以充值喔', customClass:"h5msg", type: 'error'  });
                }else{
                   _this.$message({ message: '输入暖暖星球号请先点击右边的确认按钮', customClass:"h5msg",   type: 'error' });
                }
                return
            }
     if(_this.zdyinputval !=0){
          _this.price = _this.zdyinputval
          if(chargeTypeStr == 'WX' &&  _this.zdyinputval>6000){
             _this.$message({ message: '您的订单超出微信单笔限额,请选择其他支付!', customClass:"h5msg", type: 'error'  });

          // this.$alert('您的订单超出微信单笔限额,请选择其他支付!', '提示', { customClass:'minalertH5', confirmButtonText: '确定',   });
              return
          }else if(!_this.iswxplay&&  _this.zdyinputval>10000){
       _this.$message({ message: '您的订单超出支付宝单笔限额，请选择其他支付', customClass:"h5msg", type: 'error'  });
                  // this.$alert('您的订单超出支付宝单笔限额，请选择其他支付!', '提示', {customClass:'minalertH5',  confirmButtonText: '确定',   });
              return
          }
          if(_this.zdyinputval<2){
        _this.$message({ message: '单笔充值最低2元', customClass:"h5msg", type: 'error'  });
                // this.$alert('单笔充值最低2元', '提示', {customClass:'minalertH5', confirmButtonText: '确定',   });
              return
          }
            }
            if(chargeTypeStr == 'WX'){
              _this.iswxplay = true
            }else{
               _this.iswxplay = false
            }
       _this.chargeType= chargeTypeStr 
          _this.tidialog = true
    },
    play(){
       var _this = this


         _this.$http.get(_this.$api.getChargeOrderForH5, {
                params: {
                  osType: _this.isios,
                  chargeTypeStr:  _this.chargeType,
                  code: _this.playcode,
                  source:1,
                   customPrice:_this.zdyinputval,
                  uid: _this.userid?_this.userid:0,
                }
              }
          ).then(function (response) {
                console.log(response.data);
                _this.tidialog = false
                    if(response.data.state){
                if(_this.chargeType == 'WX'){    
                        window.location.href = response.data.orderInfo.mweb_url
                  
                    }else{
                       window.location.href = response.data.orderInfo
                      // _this.zhifubao = response.data.orderInfo
                    // $(".zhifubao").html(response.data.orderInfo)
                    }
                }else{
                  _this.$message({ message:response.data.msg , customClass:"h5msg", type: 'error'  });  
                }
              })
    },
    is_ios() {
        var u = navigator.userAgent, app = navigator.appVersion;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//是否IOS
        return isiOS;
    }
    },
}
</script>
<style lang="less" scoped>
    @font-face{
      font-family: Alternate;
      src: url('https://resource.imbeiyu.com/nuannuan/h5/DIN Alternate Bold.ttf'),
    }
    .cztxt{background: #fff; margin-top: .3rem;}
    .cztxt p{font-size: .2rem; margin-bottom: .15rem;  line-height: .35rem; color: rgba(0, 0, 0, 0.5); padding: 0 .3rem; box-sizing: border-box; }
    .tabs {
      font-size: .48rem;
      width: 100%;
      background-color: #fff;
      height: 1.33rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tabs span {
      text-align: center;
      line-height: 1rem;
      font-family: PingFangSC-Medium, PingFang SC;
      display: block;
      width: 3rem;
      font-weight:400;
      color:rgba(153,153,153,1);
      position: relative;
    }
    .tabs .active {
        color:rgba(50,51,51,1);font-weight:600;
    }
    .tabs .active:after {
      content: "";
      left: 1.2rem;
      position: absolute;
      bottom:0rem;
      width: .75rem;
      background-color: #FF205E;
      height:.05rem;
    }
    .vip {
      padding: .32rem .32rem;
      box-sizing: border-box;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .vip .head {
      display: block;
      color: #000000;
      font-weight: 600;
      font-size: .37rem;
      height: 1rem;
      line-height: 1rem;
    }
    .vip .vip_tab {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: .10rem;
    }
    .vip .vip_tab span {
      display: block;
      width: 3.37rem;
      height: 1.33rem;
    }
    .vip .vip_tab .span0_on {
      background: url(https://resource.imbeiyu.com/20191118/bg_vip1_on.png);
      background-size: 100% 100%;
    }
    .vip .vip_tab .span0_off {
      background: url(https://resource.imbeiyu.com/20191118/bg_vip1_off.png);
      background-size: 100% 100%;
    }
    .vip .vip_tab .span1_on {
      background: url(https://resource.imbeiyu.com/20191118/bg_vip2_on.png);
      background-size: 100% 100%;
    }
    .vip .vip_tab .span1_off {
      background: url(https://resource.imbeiyu.com/20191118/bg_vip2_off.png);
      background-size: 100% 100%;
    }
.vip_time_tabs {

  width: 100%;

}
 .vip_time_tabs .vip_time{
  position: relative;  width: 3.04rem;  height:1.24rem; display: flex; flex-direction: column;
  border:1Px solid #C2912E;font-weight: 500;
  border-radius:.2rem;font-size:.30rem;align-items: center;justify-content: center;color: #C2912E;
   margin-bottom: .2rem;
 }
 .vip_time_txt{
   font-size: .24rem; color: #666;
 }
.vip_tab {

  margin-bottom: .10rem;
}
.listhy{
  width: 100%; display: flex; align-items: center; flex-wrap: wrap;
}
.listhy li{
  position: relative;  width: 29.2%;  height:1.24rem; display: flex; flex-direction: column;
   border:1Px solid rgba(204,204,204,1);font-weight: 500;
   border-radius:.25rem;font-size:.30rem;align-items: center;justify-content: center;color: #333333;
    margin: .12rem;
  }
  .listhy .active{
    color: #C2912E;border:1Px solid #C2912E;
    }
    .listhy .active .activeicon{
      position: absolute; background:  url('https://resource.imbeiyu.com/20210616/img/icon-select-gold.png');
      background-size: 100% 100%; width: .5rem; height: .36rem; bottom: 0; right: 0;
    }
.vip .vip_txt {
  color: rgba(28, 116, 242, 1);
  font-size: .24rem;
  margin-bottom: .40rem;
}
    .vip .vip_time_tabs span i {
      display: block;
      font-style: normal;
      color: #999999;font-family:Alternate ;
    }
    .vip .vip_time_tabs span .icon {
      position: absolute;
      width: .36rem;
      height: .14rem;
      background: url(https://resource.imbeiyu.com/20191118/tag_vip3.png);
      background-size: 100% 100%;
      right: 0;
      top: 0;
    }
    .vip .vip_time_tabs .active {
      background: url(https://resource.imbeiyu.com/20191118/bg_money_on.png);
      background-size: 100% 100%;
      color: #FF205E;
    }
    .vip .vip_time_tabs .active i {
      color: #FF205E;
    }
    .vip .vip_txt {
      color: #FF205E;
      font-size: .32rem;
      margin-bottom: .40rem;
    }
    .bottom_tip {
      font-size: .12rem;
      color: #999999;
      text-align: center;
      margin-top: .4rem;
    }
    .vip .button {
      display: block;
      margin: 0 auto;
      margin-bottom: .30rem;
      background: url(https://resource.imbeiyu.com/20191118/btn_red_220.png);
      background-size: 100% 100%;
      width: 2.40rem;
      height: 44Px ;
    }


    .hidden {
        display: none !important;
    }

    .money_btn {
        width: .50rem;
        border: 1Px #9E9D90 solid;
        text-align: center;
        border-radius:.4rem;
        color: #3C3C3C;
        font-size: .15rem;
    }

    .login_btn {
        width: .80rem;
        border: 1Px #D3842D solid;
        text-align: center;
        border-radius:.4rem;
        color: #D3842D;
        line-height: .25rem;
        font-size: .15rem;
    }

    .page {
        background-color: #fff;
        overflow-x: hidden;
        padding-bottom: .5rem;
    }

    .user_head {
        width: 100%;
        text-align: center;
        margin-top: -.30rem;
        position: absolute;
    }

    .user_head_img {
        width: .60rem;
        border-radius: 100%;
    }

    .login_cell {
        margin-top: 2.87647059em;
        background-color: #FFFFFF;
        line-height: 1.41176471;
        font-size: .17rem;
        position: relative;
        padding-bottom: .20rem;
    }

    .user_login_out {
        text-align: right;
        width: 100%;
        padding-top: 0.6rem;
        z-index: 999;
        position: absolute;
    }

    .login_out_btn {
        width: .70rem;
        margin-right: .10rem;
        margin-left: auto;
        font-size: 0.9rem;
        color: #CF7818;
    }

    .user_name {
        text-align: center;
        font-weight: bold;
        padding-top: 2.3rem;
    }

    .user_uid {
        text-align: center;
        color: #878787;
        font-size: .15rem;
    }

    .text_area {
        text-align: center;
    }


    .userof{
        width: 100%; height: 1.39rem;            font-size: .45rem;
      position: relative;   background: #fff;
        display: flex; align-items: center;
        box-sizing: border-box; padding: 0 .26rem;
      }
      .userimg{
        width: 1.07rem ;height: 1.07rem; border-radius: 50%;
      }
      .headbox{
        margin-left: .20rem;
      }
      .headbox p:nth-child(2){
        font-size: .32rem;
        color: rgb(153, 153, 153);
        margin-top: .05rem;
      }
      .chargenum{
        position: absolute;
        top: .3rem;
        right: .26rem;
        font-size: .37rem;
        line-height: .85rem;
        /* padding-right: .13rem; */
        color: #fff;text-align: center;
        width: 2.13rem ;height: .85rem;border-radius: .40rem;
        background:linear-gradient(90deg,#4592FE 0%,#50DDFE 100%);
      }




    .notice_area {
        text-align: left;
        padding-top: .5rem;
        color: #F32A2A;
    }

    .notice_msg {
        padding-left: 1rem;
    }

    .login_submit_btn {
        width: 70%;
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding-left: .14rem;
        padding-right: .14rem;
        font-size: .18rem;
        text-align: center;
        text-decoration: none;
        color: rgb(0, 0, 0);
        line-height: 2.1;
        border-radius: .10rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .login_submit_btn:after {
        content: " ";
        width: 200%;
        height: 200%;
        position: absolute;
        top: 0;
        left: 0;
        border: 1Px solid rgb(155, 155, 142);
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        border-radius: .10rem;
    }

    .login_submit_btn_on_hove {
        background-color: #F7F7F7;
        color: #C9C9C9;
    }

    .help_info {
        text-align: center;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
        color: #2E7EF1;
        font-size: 0.9rem;
    }

    .charge_list_item {
        padding-top: .13rem;
        padding-bottom: .13rem;
    }

    #charge_list {
        margin-top: .5rem;
    }
    .inpubox{
        padding: 0 0.3rem;
        /* margin-top: .3rem; */
        /* border-top:1Px solid #ccc ; border-bottom:1Px solid #ccc  ; */
        box-sizing: border-box;
        position: relative;
        height: 1.39rem;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #fff; 
    }
    .uid_input {
        display: block;
        width: 100%;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 0.43rem;
        color: #333333;
        height: 1rem;
        line-height: 1rem;
        text-align: left;
    }
    .switch_login {
        /* display: none; */
        font-size: 0.37rem;
        position: absolute;
        top: .27rem;
        right: .3rem;
        line-height: .85rem;
        /* padding-right: .13rem; */
        color: #fff;text-align: center;
        width: 1.71rem ;height: .85rem;border-radius: .40rem;
        background:linear-gradient(90deg,#4592FE 0%,#50DDFE 100%);
    }
      
    /* .uid_input::-ms-clear {
        display: none;
    }

    .uid_input:valid + .clear {
        display: inline;
    } */

    .charge_cat_name {
        width: 38%;
        display: inline-block;
    }

    .bottom_tips {
        text-align: center;background: #fff;
        color:rgba(153,153,153,1);
        font-size: 0.26rem;
        margin-top: .4rem;
    }
    .txtmsg{
        height:.8rem ; font-size: 0.37rem;width: 100%;
        display: flex;justify-content: space-between; align-items: center;
        background: #f0f0f0;
      }
      
      .txtmsg .head {
        padding-left: 0.32rem;
        font-size: 0.37rem;
        color: #FF205E;
        font-family: PingFangSC;
        font-weight: 500;
      }
      .headri{
        font-size: 0.37rem;
        color: #FC8018 ; padding-right: 0.32rem;
        font-family: PingFangSC;
        font-weight: 500;
      }
    .con_box{
        background: #fff;
      margin-top: 1Px;
      }
      .listbox .listul{
        display: flex; flex-wrap: wrap; box-sizing: border-box;
        padding: .1rem .32rem .4rem .32rem ;
      }
       .zdy_title{
      padding-left: .32rem; 
      font-size:.37rem;
      font-weight:600;
      color:rgba(0,0,0,1); 
    }
    .zdy_title span{
      font-size:.26rem;
      font-weight:400;
      color:rgba(153, 153, 153, 1);  
    } 
    .zdybox{
      display: flex; align-items: center; height: 1.8rem;
      padding-left: .24rem;
    }
    .zdyinput{
      width: 2.8rem;  height: 1rem;
      background: #FFFFFF;font-size: .44rem; color: rgba(255, 32, 94, 1);
      border-radius: .20rem;text-align: center;  border:1Px solid #CCCCCC;    
    }
    .zdytxt{
      font-size:.24rem;
      font-weight:400; padding-left: .1rem;
      color:rgba(51, 51, 51, 1); 
    }
      .listbox .list_title{
          padding-left: .43rem; padding-top: .43rem;
        font-size:.37rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:600;
        color:rgba(0,0,0,1);
      }
      .listul li{
        position: relative;  width: 29.2%;  height:2.03rem; display: flex; flex-direction: column;
        border:1Px solid rgba(204,204,204,1);
        border-radius:.25rem;font-size:.30rem;align-items: center;justify-content: center;color: #333333;
          margin: .12rem;
        }
      .listul .active{
      color: #FF205E; border:1Px solid #FF205E;
      }
      .listul li p:nth-child(1) span{
        font-size:.64rem;font-weight:bold;font-family:Alternate ;
      }
      .listul li p:nth-child(1) span span{
        font-size:.43rem;font-weight:400;
      }
      .listul li p:nth-child(2) {
        font-size:.37rem; color: #999999;font-family:Alternate ;
      }
      .listul .active p:nth-child(2) {
        font-size:.37rem; color: #FF205E;
      }
      .active .activeicon{
        position: absolute; background:  url('https://resource.imbeiyu.com/jiaren/h5/icon_select.png');
        background-size: 100% 100%; width: .5rem; height: .36rem; bottom: 0; right: 0;
      }
      .songicon{
        position: absolute; background:  url('https://resource.imbeiyu.com/jiaren/h5/tag_song_52.png');
        background-size: 100% 100%; width: 1.04rem; height: .5rem; top: -.12rem; right:-.1rem;
        font-size:.2rem;color:rgba(255,255,255,1); text-align: center; line-height: .42rem;
      }
      .playtitle{
        width: 100%; font-size:.37rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:600;padding-left: .43rem;
        color:rgba(0,0,0,1);
        line-height:.50rem;
      }
      .play{
        display: flex; justify-content: space-between; box-sizing: border-box; padding: .2rem .32rem .4rem .32rem;
      }
      .wxlay{
        background:  url('https://resource.imbeiyu.com/jiaren/h5/bg_pay_wechat.png');
        background-size: 100% 100%; width: 48%; height: 1.37rem;
      }
      .zfbplay{
        background:  url('https://resource.imbeiyu.com/jiaren/h5/bg_pay_ali.png');
        background-size: 100% 100%; width: 48%; height: 1.37rem;
      }
      .wxfuzhi{
        border:1Px solid rgba(255,32,94,1); font-size: 12Px;color: #FF205E;  padding: 1Px 10Px;; 
        border-radius: 14Px; text-align: center;background:rgba(255,255,255,1);
      }
      .qqfuzhi{
        border:1Px solid rgba(255,32,94,1); font-size: 12Px;color: #FF205E;  padding: 1Px 10Px;; 
        border-radius: 14Px; text-align: center;background:rgba(255,255,255,1);
      }
      /* .layui-m-layerchild{
        border-radius:.32rem !important; 
      } */
      .chonzhiop .layui-m-layercont{
        padding: 10Px 0 !important; 
      }
      .chonzhiop .layui-m-layercont p{
        color: #999999;
      }
      .chonzhiop .layui-m-layercont p span{
        color: #666;
      }
      .suanguo_loading_img {
        margin-top: 15%;
        width: 40%;
    }

    .suanguo_loading_toast_content {
        margin-top: 5%;
        font-size: 14Px;
    }

    .help_info_detail {
        position: fixed;
        z-index: 1;
        width: 100%;height: 100%;
        top: 0; padding: .3rem .44rem; box-sizing: border-box;
        background: rgba(0, 0, 0, 0.0);
        overflow-y: scroll; font-size:.4rem;
        -webkit-overflow-scrolling: touch;
    }

    .help_info_detail_content {
        width: 100%;height: 100%;
        background-color: #fff;
      
    }

    .close_helper_btn {
        position: fixed;
        top: .3rem;
        left: .4rem;
        z-index: 99;
        width: .48rem;
        height: .48rem;
    }

    #close_helper_btn_img {
        width: 100%;
    }

    .helper_info_title_strong {
        font-size:.4rem;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400; text-align: left;
        color:rgba(252,128,24,1);
        margin-bottom: .3rem;
        
    }

    .red {
        color: red;
    }

    .helper_info_title {
        padding: .30rem 0;
        margin-top: .3rem;
        font-size:.32rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:600;
        color:rgba(51,51,51,1);
    }

    .helper_info_img {
      width: 6.4rem;
    }

    .charge_cat_desc {
        color: rgb(153, 153, 153);
    }
    .pic_guide_jiaren{
      position: absolute; top: 0;width: 100%; height: 100%;
      background:rgba(0,0,0,1);z-index: 999;

    }
    .pic_guide_img{
      background:  url('http://resource.imbeiyu.com/lhp/202000619/img/pic_guide_jiaren.png');
      background-size: 100% 100%; width: 100%; height: 5.58rem;position: absolute;top: 0;
    }  
    .heradbox{
        width: 100%; height: 1.33rem; background: #fff;position: relative;
        margin-bottom: .22rem;font-size:0.48rem;color: #333333;
        line-height: 1.33rem; text-align: center; font-weight: 500;
            .tabicon{
      background:  url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-more-black.png');
      background-size: 100% 100%;  position: absolute;
      right: .34rem; top: .3rem;  width: .7rem; height:.75rem; 
    }
    } 

      .tanbox{
       position: fixed;background:rgba(0,0,0,0.6); top: 0;
         width: 100%; height: 100%;z-index: 99;
         .tixianbox{
           position: relative;  width: 85%; background: #ffffff;
             border-radius: .33rem; margin: 50% auto 0 auto;
            padding: .48rem .5rem 1.47rem .5rem; box-sizing: border-box;
             p{
               padding: 0 .3rem; box-sizing: border-box;  width: 100%; font-size:.43rem;  
                color:rgba(51,51,51,1); line-height: .64rem;
             display: flex;  align-items: center;
             span{
                 width: 50%; white-space: nowrap;
                 overflow: hidden;
                 text-overflow: ellipsis;
             }
             span:nth-child(1){
               text-align: right;color: #999999;
             }
             span:nth-child(2){
               text-align: left; color: #666; margin-left:.2rem ;
             }
             }
             h6{
               font-size:0.26rem;width: 100%;text-align: center;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400; margin-top: .27rem;
              color:rgba(204,204,204,1);
             }
          .title{
           margin-bottom: .24rem;   text-align: center;  font-size:.51rem;
           color:rgba(51,51,51,1); width: 100%; text-align: center; font-weight: 500;
          }
    
          .btns{
           display: flex;width: 100%;  position: absolute; bottom: 0rem;left: 0;
           button{
             font-size: .45rem;   width: 50%; height:1.18rem ;background: #fff; 
           border-top: .5Px solid #EDEDED;  color: #666666;
          } 
            button:nth-child(1){
             border-right: .5Px solid #EDEDED;  
             border-bottom-left-radius: .33rem;
            }  
            button:nth-child(2){
             border-right: .5Px solid #EDEDED; 
              border-bottom-right-radius: .33rem; color: #1C74F2;
            }  
          }
      
         }
        }
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5recharge.vue